<template>
  <div class="w-full border-b dark:border-gray-950">
    <ClientOnly>
      <el-menu mode="horizontal" :default-active="useOoloja.menuitem" :ellipsis="true">
        <template v-for="(menu, index) in menus">
          <el-sub-menu :index="menu.key" :key="menu.index" v-if="menu.submenu.length > 0">
            <template #title>
              <NuxtIcon :name="`${menu.icon}`" class="mr-2 text-[20px]" filled />
              {{ menu.title }}
            </template>

            <template v-for="(submenu, index) in menu.submenu">
              <el-sub-menu :index="submenu.key" v-if="submenu.submenu.length > 0">
                <template #title>{{ submenu.title }}</template>
                <el-menu-item
                  :index="s2.key"
                  v-for="(s2, index) in submenu.submenu"
                  @click="handleSelect(s2.link, submenu.key)"
                >
                  {{ s2.title }}
                </el-menu-item>
              </el-sub-menu>

              <el-menu-item
                v-else
                :index="submenu.key"
                @click="handleSelect(submenu.link, submenu.key)"
              >
                <template #title>
                  {{ submenu.title }}
                </template>
              </el-menu-item>
            </template>
          </el-sub-menu>
          <el-menu-item
            :index="menu.key"
            :key="index"
            @click="handleSelect(menu.link, menu.key)"
            v-else
          >
            <template #title>
              <NuxtIcon :name="`${menu.icon}`" class="mr-2 text-[20px]" filled />
              {{ menu.title }}
            </template>
          </el-menu-item>
        </template>
      </el-menu>
    </ClientOnly>
  </div>
</template>

<script setup>
import { useStoreOoloja } from "@/stores/ooloja";
const useOoloja = useStoreOoloja();

const useConfig = useRuntimeConfig();

const handleSelect = async (link, key) => {
  useOoloja.setMenuItem(key);
  if (link.length > 0 && link !== "#") {
    await navigateTo(link, { external: false });
  }
};

const menus = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: "bag",
    link: "/ooloja",
    submenu: [],
  },
  {
    key: "clientes",
    title: "Clientes",
    icon: "clientes",
    link: "/ooloja/cadastros/clientes",
    submenu: [],
  },
  // {
  //   key: "4",
  //   title: "Navigator Three",
  //   icon: "odometer",
  //   link: "/ooloja/catalogo/produtos",
  //   submenu: [],
  // },
  // {
  //   key: "5",
  //   title: "Navigator Four",
  //   icon: "odometer",
  //   link: "",
  //   submenu: [],
  // },
];

if (useConfig.public.ERP_PSI_ON == "false") {
  menus.push({
    key: "catalogo",
    title: "Catalogo",
    icon: "catalogo",
    link: "#",
    submenu: [
      {
        key: "catalogo-produtos",
        title: "Produtos",
        link: "/ooloja/catalogo/produtos",
        submenu: [],
      },
      {
        key: "catalogo-categorias",
        title: "Categorias",
        link: "/ooloja/catalogo/categorias",
        submenu: [],
      },
      {
        key: "catalogo-marcas",
        title: "Fabricantes/Marcas",
        link: "/ooloja/cadastros/fabricantes",
        submenu: [],
      },
      {
        key: "catalogo-variacoes",
        title: "Variaçoes",
        link: "/ooloja/catalogo/variacoes",
        submenu: [],
      },
    ],
  });
}

if (useConfig.public.ERP_PSI_ON == "true") {
  menus.push({
    key: "3",
    title: "Atacado",
    icon: "bag",
    link: "#",
    submenu: [
      {
        key: "atacado-carrinhos",
        title: "Carrinhos",
        link: "/ooloja/atacado/carrinhos",
        submenu: [],
      },
      {
        key: "atacado-pedidos",
        title: "Pedidos",
        link: "/ooloja/atacado/pedidos",
        submenu: [],
      },
    ],
  });
}

if (useOoloja.configuracoes.condicoes_parcelamento_status) {
  // Encontrar o objeto com key "3" no array menus
  const atacadoMenu = menus.find((menu) => menu.key === "3");
  if (atacadoMenu) {
    atacadoMenu.submenu.push({
      key: "atacado-condicoes_parcelamento",
      title: "Condições de Parcelamento",
      link: "/ooloja/atacado/condicoes-parcelamento",
      submenu: [],
    });
  }
}
</script>

<style lang="scss" scoped>
.el-menu-item a {
  width: 100%;
  display: block;
}

.el-menu {
  border: none;
}
</style>
